import { render, staticRenderFns } from "./Fish.vue?vue&type=template&id=138102c4&scoped=true"
import script from "./Fish.vue?vue&type=script&lang=js"
export * from "./Fish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138102c4",
  null
  
)

export default component.exports